<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-pricing-hero-section></app-pricing-hero-section>
  <!-- Plans -->
  <app-pricing-plans-section></app-pricing-plans-section>
  <!-- App Icons -->
  <app-app-icon-section></app-app-icon-section>
  <!-- Promise -->
  <app-pricing-promise-section id="promise"></app-pricing-promise-section>
  <!-- FAQ -->
  <app-pricing-faq-section id="faq"></app-pricing-faq-section>
  <!-- CTA -->
  <app-cta-section id="cta"></app-cta-section>
</div>
